// placeholder の表記ルールについては以下を参照
// https://ikyu.atlassian.net/wiki/spaces/DES/pages/6357090305#%E3%83%97%E3%83%AC%E3%83%BC%E3%82%B9%E3%83%9B%E3%83%AB%E3%83%80%E3%83%BC

type Placeholder = {
  nameKana: string
  phoneNumber: string
  email: string
}

const ikyuPlaceholder = {
  // 姓名の間に半角スペースを入れる
  // https://github.com/ikyucom/macaron-frontend/pull/2982
  nameKana: 'いっきゅう たろう',
  // 実際に割当可能な電話番号を利用しないように注意
  // https://ikyu.slack.com/archives/C064RV8PRQA/p1705573141033429
  phoneNumber: '09001234567',
  email: 'ikyu19@example.com',
} as const satisfies Placeholder

const ppgPlacaeholder = {
  // 姓名の間に半角スペースを入れる
  // https://github.com/ikyucom/macaron-frontend/pull/2982
  nameKana: 'せい めい',
  // 実際に割当可能な電話番号を利用しないように注意
  // https://ikyu.slack.com/archives/C064RV8PRQA/p1705573141033429
  phoneNumber: '09001234567',
  email: '○○○@yahoo.co.jp',
} as const satisfies Placeholder

export const placeholder = import.meta.env.VITE_MODE === 'ppg' ? ppgPlacaeholder : ikyuPlaceholder
